import {
  LOTTERY_SHARED_TICKET_LIST_REQUEST,
  LOTTERY_SHARED_TICKET_LIST_SUCCESS,
  LOTTERY_SHARED_TICKET_LIST_FAILURE,
  LOTTERY_SHARED_TICKET_LIST_RESET,
  LOTTERY_SHARED_TICKET_DETAIL_REQUEST,
  LOTTERY_SHARED_TICKET_DETAIL_SUCCESS,
  LOTTERY_SHARED_TICKET_DETAIL_FAILURE,
  LOTTERY_SHARED_TICKET_DETAIL_RESET,
  LOTTERY_SHARED_TICKET_BUY_REQUEST,
  LOTTERY_SHARED_TICKET_BUY_SUCCESS,
  LOTTERY_SHARED_TICKET_BUY_FAILURE
} from 'Store/constants';

const initialState = {
  ticketList: {
    data: {},
    isLoading: null,
    error: null
  },
  ticketDetail: {
    data: {
      name: '',
      tickets: {},
      remainingShareCount: 0,
      sharePrice: 0,
      totalShareCount: 0
    },
    isLoading: null,
    error: null
  },
  ticketSlip: {
    data: {},
    isLoading: null,
    error: null
  }
};

export default (state = initialState, action) => {
  switch (action.type) {

    case LOTTERY_SHARED_TICKET_LIST_REQUEST:
      return {
        ...state,
        ticketList: {
          ...state.ticketList,
          isLoading: true,
          error: null
        }
      };

    case LOTTERY_SHARED_TICKET_LIST_SUCCESS:
      return {
        ...state,
        ticketList: {
          data: { ...action.payload },
          isLoading: false,
          error: null
        }
      };

    case LOTTERY_SHARED_TICKET_LIST_FAILURE:
      return {
        ...state,
        ticketList: {
          ...state.ticketList,
          isLoading: false,
          error: action.payload
        }
      };

    case LOTTERY_SHARED_TICKET_LIST_RESET:
      return {
        ...state,
        ticketList: initialState.ticketList
      };

    case LOTTERY_SHARED_TICKET_DETAIL_REQUEST:
      return {
        ...state,
        ticketDetail: {
          ...state.ticketDetail,
          isLoading: true,
          error: null
        }
      };

    case LOTTERY_SHARED_TICKET_DETAIL_SUCCESS:
      return {
        ...state,
        ticketDetail: {
          data: { ...action.payload },
          isLoading: false,
          error: null
        }
      };

    case LOTTERY_SHARED_TICKET_DETAIL_FAILURE:
      return {
        ...state,
        ticketDetail: {
          ...state.ticketDetail,
          isLoading: false,
          error: action.payload
        }
      };

    case LOTTERY_SHARED_TICKET_DETAIL_RESET:
      return {
        ...state,
        ticketDetail: initialState.ticketDetail
      };

    case LOTTERY_SHARED_TICKET_BUY_REQUEST:
      return {
        ...state,
        ticketSlip: {
          ...state.ticketSlip,
          isLoading: true,
          error: null
        }
      };

    case LOTTERY_SHARED_TICKET_BUY_SUCCESS:
      return {
        ...state,
        ticketDetail: {
          ...state.ticketDetail,
          data: {
            ...state.ticketDetail.data,
            ...action.payload
          }
        }
      };

    case LOTTERY_SHARED_TICKET_BUY_FAILURE:
      return {
        ...state,
        ticketSlip: {
          ...state.ticketSlip,
          isLoading: false,
          error: action.payload
        }
      };

    default:
      return state;
  }
};
